var exports = {
  "D": "x2b2fbebb--ac9161--title",
  "m": "x2b2fbebb--ac9161--textfield",
};

module.exports = exports;
